import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import service from '@services/passenger-bus'

export const fetchBuses = createAsyncThunk('passengerBuses/fetchBuses', async (params, { rejectWithValue }) => {
  try {
    const res = await service.getBuses(params)
    return { params, data: res.data, meta: res.meta }
  } catch (err) {
    return rejectWithValue(err.response?.data || err.message)
  }
})

export const fetchBus = createAsyncThunk('passengerBuses/fetchBus', async (id, { rejectWithValue }) => {
  try {
    return await service.getBus(id)
  } catch (err) {
    return rejectWithValue(err.response?.data || err.message)
  }
})

export const addBus = createAsyncThunk('passengerBuses/addBus', async (payload, { rejectWithValue }) => {
  try {
    return await service.addBus(payload)
  } catch (err) {
    return rejectWithValue(err.response?.data || err.message)
  }
})

export const saveBus = createAsyncThunk('passengerBuses/saveBus', async (payload, { rejectWithValue }) => {
  try {
    return await service.updateBus(payload)
  } catch (err) {
    return rejectWithValue(err.response?.data || err.message)
  }
})

export const removeBus = createAsyncThunk('passengerBuses/removeBus', async (id, { rejectWithValue }) => {
  try {
    await service.deleteBus(id)
    return id
  } catch (err) {
    return rejectWithValue(err.response?.data || err.message)
  }
})

const slice = createSlice({
  name: 'passengerBuses',
  initialState: {
    data: [],
    meta: null,
    params: { page: 1, take: 10, order: 'ASC', q: '' },
    selected: null,
    loading: false,
    error: null
  },
  reducers: {
    setBusParams(state, action) {
      state.params = action.payload
    }
  },
  extraReducers: builder => {
    builder
      .addCase(fetchBuses.pending, state => { state.loading = true })
      .addCase(fetchBuses.fulfilled, (state, action) => {
        state.loading = false
        state.data = action.payload.data
        state.meta = action.payload.meta
        state.params = action.payload.params
      })
      .addCase(fetchBuses.rejected, (state, action) => { state.loading = false; state.error = action.payload })
      .addCase(fetchBus.pending, state => { state.loading = true })
      .addCase(fetchBus.fulfilled, (state, action) => { state.loading = false; state.selected = action.payload })
      .addCase(fetchBus.rejected, (state, action) => { state.loading = false; state.error = action.payload })
      .addCase(addBus.fulfilled, (state, action) => { state.data.unshift(action.payload) })
      .addCase(saveBus.fulfilled, (state, action) => {
        const idx = state.data.findIndex(b => b.id === action.payload.id)
        if (idx > -1) state.data[idx] = action.payload
      })
      .addCase(removeBus.fulfilled, (state, action) => { state.data = state.data.filter(b => b.id !== action.payload) })
  }
})

export const { setBusParams } = slice.actions
export default slice.reducer
